window.onload = function() {
  //禁止F5刷新 禁用ctrl+R刷新
  document.onkeydown = function (e) {
    if (e.keyCode === 116 || (e.ctrlKey && e.keyCode === 82) ) {
      return false;
    }
  }
};